import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const DashboardPage = lazy(() => import('./views/dashboard'));

const internationalProjectsRoutes: RouteObject = {
	id: 'international-projects',
	path: '/international-projects',
	element: <DashboardPage />,
};

export default internationalProjectsRoutes;
